<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><a class="page" id="piv"></a>The History and Philosophy of Education Series is published in cooperation with the Association for Philosophy of Education and the History of Education Society.</p>
<p class="crtf">The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2018 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2018</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">27 26 25 24 23 22 21 20 19 18    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-55225-5 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-55239-2 (paper)</p>
<p class="crt">ISBN-13: 978-0-226-55242-2 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226552422.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226552422.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip">Names: Curren, Randall R., author. | Dorn, Charles, author.</p>
<p class="cip">Title: Patriotic education in a global age / Randall Curren and Charles Dorn.</p>
<p class="cip">Other titles: History and philosophy of education.</p>
<p class="cip">Description: Chicago ; London : The University of Chicago Press, 2018. | Series: The history and philosophy of education series</p>
<p class="cip">Identifiers: LCCN 2017040697 | ISBN 9780226552255 (cloth : alk. paper) | ISBN 9780226552392 (pbk. : alk. paper) | ISBN 9780226552422 (e-book)</p>
<p class="cip">Subjects: LCSH: Patriotism—Study and teaching—United States. | Nationalism—Study and teaching—United States.</p>
<p class="cip">Classification: LCC LC1091 .C97 2018 | DDC 372.83—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2017040697" target="_blank">https://lccn.loc.gov/2017040697</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI/NISO Z39.48–1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-curren-0005.vue?2f565306